import { FaqServiceSupportThemeModeConfig } from './types';

const dark: FaqServiceSupportThemeModeConfig = {
  faqServiceSupport: {},
};

export default dark;
